import * as THREE from "three";
// Source bare_arm meshes contain both fingers and an entire forearm. Keep the
// hand portion when layering gloves over the selected agent's existing sleeves.
export function gloveGeometry(mesh: THREE.Mesh, boneNames: string[]) {
  const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
  if (!materials.every(m => m.name.includes("bare_arm"))) return mesh.geometry;
  const source = mesh.geometry, joints = source.getAttribute("skinIndex"), weights = source.getAttribute("skinWeight");
  if (!joints || !weights) return source;
  const hand = new Set(boneNames.flatMap((name,i)=>/^(hand_|finger_)/.test(name)?[i]:[]));
  const index = source.index, count = index?.count ?? joints.count, kept:number[]=[];
  const influence=(v:number)=>[0,1,2,3].reduce((sum,c)=>sum+(hand.has(joints.getComponent(v,c))?weights.getComponent(v,c):0),0);
  for(let i=0;i<count;i+=3){
    const triangle=[0,1,2].map(n=>index?index.getX(i+n):i+n);
    if(triangle.reduce((sum,v)=>sum+influence(v),0)/3 >= .5) kept.push(...triangle);
  }
  const result=source.clone();result.setIndex(kept);result.clearGroups();return result;
}
